import { render } from "./CosmeticServices.vue?vue&type=template&id=3e41086d"
import script from "./CosmeticServices.vue?vue&type=script&lang=js"
export * from "./CosmeticServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__